import { Directive } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class EaProductInitFormBuilder extends PrFormAbstract {
  options: any = {};
  isAutomaticFlux: boolean;

  generate(entity: any, options?) {
    this.options = options;

    let group = this.formBuilder.group({
      operation: [entity?.operation || 'SUBSCRIPTION', Validators.required],
      operationAssetContractId: [entity?.operationAssetContractId || null],
      product: [entity?.label || null, Validators.required],
      gridkyPropertyId: [entity?.gridkyPropertyId || null],
      loanId: [entity?.loanId || null],
      borrowerInsuranceContext: [entity?.borrowerInsuranceContext || null],
      borrowerInsuranceMode: [entity?.borrowerInsuranceMode || null],
      allowedApiFlux: [entity?.allowedApiFlux || false],
    });

    this.form = group;

    return group;
  }

  extract() {}
}
